import { useI18n } from 'vue-i18n'
import { useDayJs } from '@/shared/composables/use-dayjs'

function effectiveDate(notification) {
  return notification?.scheduledAt || notification?.createdAt
}

export function useNotificationDate() {
  const { t } = useI18n()
  const { dayJsObject } = useDayJs()

  function formatShortDate(notification) {
    const date = dayJsObject(effectiveDate(notification))
    const today = dayJsObject()

    if (date.isSame(today, 'day')) {
      return date.format('h:mm A')
    }

    if (date.isSame(today.subtract(1, 'day'), 'day')) {
      return t('notifications.yesterday')
    }

    return date.format('MMM D')
  }

  function formatFullDate(notification) {
    return dayJsObject(effectiveDate(notification)).format('MMM D, h:mm A')
  }

  return { effectiveDate, formatShortDate, formatFullDate }
}
